<template>
  <div>
    <p class="subtitle-2 mb-0" style="color: rgba(0,0,0,0.7)">Participantes</p>
    <p class="caption grey--text mb-3">Selecione os colaboradores desta meta.</p>

    <v-text-field
      v-model="filtroColaborador"
      placeholder="Filtrar colaboradores..."
      outlined
      dense
      prepend-inner-icon="mdi-magnify"
      hide-details
      class="mb-3"
    ></v-text-field>

    <div v-if="loading" class="d-flex justify-center py-6">
      <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
    </div>

    <div v-else style="padding-right: 4px">
      <template v-for="funcao in funcoesUnicas">
        <div
          v-if="!filtroColaborador || getColaboradoresFiltrados(funcao).length > 0"
          :key="funcao"
          class="mb-2 rounded"
          :style="
            algunsSelecionados(funcao)
              ? 'border: 1px solid #1976d2; background: rgba(25,118,210,0.05)'
              : 'border: 1px solid rgba(0,0,0,0.12); background: white'
          "
        >
          <div
            class="d-flex align-center pa-2 rounded-t"
            :style="
              algunsSelecionados(funcao)
                ? 'background: rgba(25,118,210,0.1)'
                : 'background: rgba(0,0,0,0.04)'
            "
          >
            <v-checkbox
              :input-value="todosSelecionados(funcao)"
              :indeterminate="algunsSelecionados(funcao) && !todosSelecionados(funcao)"
              @change="toggleTodosDaFuncao(funcao, $event)"
              hide-details
              dense
              class="mt-0 pt-0 flex-shrink-0"
            ></v-checkbox>
            <div class="flex-grow-1">
              <p
                class="caption font-weight-bold text-uppercase ma-0"
                style="letter-spacing: 0.05em; color: rgba(0,0,0,0.7)"
              >
                {{ getCodFuncao(funcao) }} - ({{ getIdFuncao(funcao) }}) - {{ funcao }}
              </p>
              <p class="caption grey--text ma-0">
                {{ getColaboradoresDaFuncao(funcao).length }} colaboradores
              </p>
            </div>
            <v-chip x-small outlined color="primary" class="flex-shrink-0 mr-1">
              {{ internalValue.filter(c => c._funcao === funcao).length }}/{{
                getColaboradoresDaFuncao(funcao).length
              }}
            </v-chip>
            <v-btn
              icon
              x-small
              @click="toggleFuncaoExpandida(funcao)"
              :color="funcoesExpandidas.includes(funcao) ? 'primary' : 'grey'"
            >
              <v-icon small>{{
                funcoesExpandidas.includes(funcao) ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </div>

          <div
            v-if="funcoesExpandidas.includes(funcao)"
            class="px-3 pb-2"
            style="border-top: 1px solid rgba(0,0,0,0.08); background: white"
          >
            <div
              v-for="colab in getColaboradoresFiltrados(funcao)"
              :key="`${colab.id_colaborador}|${colab.id_empresa}`"
              class="d-flex align-center mb-1 mt-1"
            >
              <v-checkbox
                :input-value="isColaboradorSelecionado(colab)"
                @change="toggleColaborador(colab, $event)"
                hide-details
                dense
                class="mt-0 pt-0 flex-shrink-0"
              ></v-checkbox>
              <span class="body-2">
                <template v-if="colab.apelido">{{ colab.apelido }} - </template>{{ colab.colaborador }}
              </span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalCadastroSubEtapaParticipantes",

  props: {
    value: { type: Array, default: () => [] },
    colaboradores: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },

  data() {
    return {
      filtroColaborador: "",
      funcoesExpandidas: []
    };
  },

  computed: {
    internalValue: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); }
    },

    funcoesUnicas() {
      return [...new Set(this.colaboradores.map(c => c._funcao))].sort((a, b) =>
        a.localeCompare(b, "pt-BR")
      );
    }
  },

  methods: {
    getIdFuncao(funcao) {
      const colab = this.colaboradores.find(c => c._funcao === funcao);
      return colab ? colab._id_funcao : "";
    },

    getCodFuncao(funcao) {
      const colab = this.colaboradores.find(c => c._funcao === funcao);
      return colab ? colab.cod_funcao : "";
    },

    getColaboradoresDaFuncao(funcao) {
      return this.colaboradores.filter(c => c._funcao === funcao);
    },

    getColaboradoresFiltrados(funcao) {
      const colabs = this.getColaboradoresDaFuncao(funcao);
      if (!this.filtroColaborador) return colabs;
      // Busca tambem pela empresa: a lista de uma funcao mistura empresas, e sem
      // isso nao ha como restringir a uma delas.
      const termo = this.filtroColaborador.toLowerCase();
      return colabs.filter(c =>
        (c.colaborador && c.colaborador.toLowerCase().includes(termo)) ||
        (c.apelido && c.apelido.toLowerCase().includes(termo)) ||
        (c.nome_empresa && c.nome_empresa.toLowerCase().includes(termo))
      );
    },

    isColaboradorSelecionado(colab) {
      return this.internalValue.some(
        c => c.colaborador === colab.colaborador && c.apelido === colab.apelido
      );
    },

    todosSelecionados(funcao) {
      const colabs = this.getColaboradoresDaFuncao(funcao);
      return colabs.length > 0 && colabs.every(c => this.isColaboradorSelecionado(c));
    },

    algunsSelecionados(funcao) {
      return this.getColaboradoresDaFuncao(funcao).some(c =>
        this.isColaboradorSelecionado(c)
      );
    },

    toggleFuncaoExpandida(funcao) {
      const idx = this.funcoesExpandidas.indexOf(funcao);
      if (idx >= 0) {
        this.funcoesExpandidas.splice(idx, 1);
      } else {
        this.funcoesExpandidas.push(funcao);
      }
    },

    toggleColaborador(colab, checked) {
      if (checked) {
        this.$emit("input", [...this.internalValue, colab]);
      } else {
        this.$emit(
          "input",
          this.internalValue.filter(
            c => !(c.colaborador === colab.colaborador && c.apelido === colab.apelido)
          )
        );
      }
    },

    toggleTodosDaFuncao(funcao, checked) {
      const colabs = this.getColaboradoresDaFuncao(funcao);
      if (checked) {
        const novos = colabs.filter(c => !this.isColaboradorSelecionado(c));
        this.$emit("input", [...this.internalValue, ...novos]);
      } else {
        this.$emit(
          "input",
          this.internalValue.filter(c => c._funcao !== funcao)
        );
      }
    }
  }
};
</script>
